import { render, staticRenderFns } from "./ItemExtrasOverlay.vue?vue&type=template&id=5251871a&scoped=true"
import script from "./ItemExtrasOverlay.vue?vue&type=script&lang=js"
export * from "./ItemExtrasOverlay.vue?vue&type=script&lang=js"
import style0 from "./ItemExtrasOverlay.vue?vue&type=style&index=0&id=5251871a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5251871a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5251871a')) {
      api.createRecord('5251871a', component.options)
    } else {
      api.reload('5251871a', component.options)
    }
    module.hot.accept("./ItemExtrasOverlay.vue?vue&type=template&id=5251871a&scoped=true", function () {
      api.rerender('5251871a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemExtrasOverlay.vue"
export default component.exports